import Layout from '@/AppSmakeProduct.vue';

const smake_product= {
    path: '/admin/orders',
    name: 'Pages',
    component: Layout,
    children:[
        {
            path: '/admin/product/:id',
            name: 'Smake Product',
            component: () => import('@/views/master_admin/product_details'),
            meta: {title: 'Smake Product', auth: true, name: 'Smake Product', middlewares:['admin']}
        }
    ]
};
export default smake_product;
